import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheSiteTransferRetrieveActions,
  SetTheSiteTransferEditsActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/REInvesment/ReInvesment.scss";
import { data } from "jquery";

const SiteTransferApprove = (props) => {
  const { currentPage, setShow, show, EditId, data, selectVal , white_collar , from_dates, to_dates ,search  } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const form_data = new FormData();
  const initialState = {
    status: "",

    user_id: "",

    client_id: "",
    to_client: "",
    user_name: "",    

    description: "",
    reason_type: "",
    firstIm: null,
    joining_date:"",
    end_date:"",
    seconImg: null,
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    dispatch(SetTheSiteTransferRetrieveActions({ EditId }));
  }, []);
  useEffect(() => {
    /// console.log(state.SiteTransferRetrieveCall.SiteTramsferDataretrieve, "datas");
    if (
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.id != undefined
      &&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.from_client != undefined &&
      
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.from_client.client_id != null
&&
      state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.from_client.client_id != undefined
    ) {
      const dateString =
        state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,

        reason_type:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.reason,

        status: state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.status,
        user_name:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.user_id
            .first_name,
        client_id:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.from_client
            .client_id != undefined &&state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.from_client
            .client_id.client_name,

        to_client:
        state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client != null &&
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client
            .client_id != undefined ?
            state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.to_client.client_id.client_name :"",
            joining_date:state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.joining_date, 
            end_date:state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.end_date,

        description:
          state.SiteTransferRetrieveCall.SiteTramsferDataretrieve
            .reason_for_decline,
      });
    }
  }, [state.SiteTransferRetrieveCall.SiteTramsferDataretrieve]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
    form_data.append(
      "data",
      JSON.stringify({
        status: Data.status.toLowerCase(),
        description:
          Data.status.toLowerCase() == "decline" ? Data.description : "",
      })
    );
    const payload = {
      //description: Data.description,
      EditId: EditId,
      currentPage: currentPage,
      data: data,
      selectVal: selectVal,
      from_client: state.ClientBranchIDs.SingelEmployeelistes,
      form_data: {
        status: Data.status.toLowerCase(),
        description:
          Data.status.toLowerCase() == "decline" ? Data.description : "",
      },
      user:state.ClientBranchIDs.EmployeeDetailsProfile,
      count:1,
      white_collar:white_collar , 
      // month: Datestate.month,
      // year: Datestate.year,
      // date:Datestate.date ,
      to_date:to_dates,  from_date :from_dates, 
      search:search,
    };
    dispatch(SetTheSiteTransferEditsActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Site Transfer Request</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Reason
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.reason_type}
                            readOnly
                          />
                        </div>

                      <div class="col-sm-3 mt-3">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Joining Date 
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    value={Data.joining_date}
                    autoComplete="off"
readOnly

                    name="joining_date"
                    style={{
                      padding: "15px",
                    }}
                  ></input>
                </div>


                <div class="col-sm-3  mt-3">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    End Date 
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    value={Data.end_date}
                    autoComplete="off"
                    readOnly
                    name="end_date"
                    style={{
                      padding: "15px",
                    }}
                  ></input>
                </div>




                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            From Branch
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.client_id}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            To Branch
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.to_client}
                            readOnly
                          />
                        </div>
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>

                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                        {Data.status.toLowerCase() == "decline" ? (
                          <>
                            <div className="col-sm-3" style={{ width: "700px" }}>
                            <br/>

                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Reason for decline
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                required
                                autocomplete="off"
                                name="description"
                                value={Data.description}
                                onChange={HandleDecriptions}
                              />
                            </div>
                          </>
                        ) : null}

                      </div>

                      <div className="row">
                        <div
                          className="row"
                          style={{ padding: "20px", marginLeft: "10px" }}
                        >
                          {state.SiteTransferRetrieveCall
                            .SiteTramsferDataretrieve.documents ? (
                            <>
                              <label
                                for="validationCustom01"
                                class="form-label"
                              ></label>
                              <div className="col mt-3 BefoereImageView">
                                {state.SiteTransferRetrieveCall.SiteTramsferDataretrieve.documents.map(
                                  (item, indes) => (
                                    <>
                                      <div className="ImagesList">
                                        <a
                                          onClick={(e) =>
                                            window.open(item.media_url)
                                          }
                                          target="blank"
                                          style={{ cursor: "pointer" }}
                                          download={item.media_url}
                                        >
                                          <img src={item.media_url} />
                                        </a>
                                      </div>
                                    </>
                                  )
                                )}
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.SiteTransferRetrieveCall
                            .SiteTramsferDataretrieve.status ==
                          Data.status.toLowerCase()
                        }
                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteTransferApprove;
